import React, { InputHTMLAttributes } from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export interface SliderProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  valueDisplay?: string | number;
}

export const Slider = React.forwardRef<HTMLInputElement, SliderProps>(
  ({ className, label, valueDisplay, value, id, ...props }, ref) => {
    const sliderId = id || (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined);

    return (
      <div className="w-full space-y-2">
        {(label || valueDisplay !== undefined) && (
          <div className="flex justify-between items-center text-[12px]">
            {label && (
              <label htmlFor={sliderId} className="font-normal tracking-tight text-muted-foreground">
                {label}
              </label>
            )}
            {valueDisplay !== undefined && (
              <span className="font-mono px-2 py-0.5 rounded-md bg-muted text-foreground text-[12px]">
                {valueDisplay}
              </span>
            )}
          </div>
        )}
        <input
          id={sliderId}
          type="range"
          ref={ref}
          value={value}
          className={twMerge(
            clsx(
              'w-full h-1.5 bg-muted rounded-lg appearance-none cursor-pointer accent-primary focus:outline-none',
              className
            )
          )}
          {...props}
        />
      </div>
    );
  }
);
Slider.displayName = 'Slider';
